(function () {
  'use strict';

  var HINT_TEXT   = 'Bitte wähle zuerst eine Box-Größe';
  var CHECK_DELAY = 200;

  function findButton() {
    return (
      document.querySelector('button[name="add"]') ||
      document.querySelector('.product-form__submit') ||
      document.querySelector('button[data-testid="add-to-cart"]')
    );
  }

  function hasFlyBundles() {
    var wrapper = document.querySelector('.gfbVolumeBundleTemplate_3_TierWrapper, [class*="gfbVolume"][class*="TierWrapper"]');
    if (!wrapper) return false;
    var rect = wrapper.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function isBundleSelected() {
    /* Radio checked */
    if (document.querySelector('input[name^="tier-"]:checked')) return true;
    /* Fallback: Wrapper-Element hat selected/active Attribut oder Klasse */
    if (document.querySelector('[class*="gfbVolume"][class*="selected"]')) return true;
    if (document.querySelector('[class*="gfbVolume"][class*="active"]')) return true;
    if (document.querySelector('[class*="gfbVolume"][data-selected="true"]')) return true;
    if (document.querySelector('[class*="gfbVolume"][aria-checked="true"]')) return true;
    return false;
  }

  function updateButton() {
    var btn = findButton();
    if (!btn) return;

    if (!hasFlyBundles()) {
      btn.removeAttribute('disabled');
      btn.style.opacity = '';
      btn.style.cursor  = '';
      var hint = document.getElementById('fly-bundle-hint');
      if (hint) hint.style.display = 'none';
      return;
    }

    var selected = isBundleSelected();

    if (!selected) {
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('title', HINT_TEXT);
      btn.style.opacity = '0.45';
      btn.style.cursor  = 'not-allowed';

      var hint = document.getElementById('fly-bundle-hint');
      if (!hint) {
        hint = document.createElement('p');
        hint.id            = 'fly-bundle-hint';
        hint.textContent   = HINT_TEXT;
        hint.style.cssText = 'text-align:center;font-size:13px;color:#c0392b;margin-top:8px;font-weight:600;';
        btn.parentNode.insertBefore(hint, btn.nextSibling);
      }
      hint.style.display = '';
    } else {
      btn.removeAttribute('disabled');
      btn.removeAttribute('title');
      btn.style.opacity = '';
      btn.style.cursor  = '';

      var hint = document.getElementById('fly-bundle-hint');
      if (hint) hint.style.display = 'none';
    }
  }

  var timer;
  function scheduleUpdate() {
    clearTimeout(timer);
    timer = setTimeout(updateButton, CHECK_DELAY);
  }

  /* Click auf Bundle-Karten direkt abfangen */
  document.addEventListener('click', function (e) {
    var target = e.target;
    /* Prüfe ob Klick innerhalb eines Fly Bundles Elements war */
    while (target && target !== document.body) {
      if (
        target.className && typeof target.className === 'string' &&
        (target.className.indexOf('gfbVolume') !== -1 || target.className.indexOf('gfbBundle') !== -1)
      ) {
        scheduleUpdate();
        return;
      }
      target = target.parentElement;
    }
  }, true); /* capture phase */

  /* Radio change */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name && e.target.name.indexOf('tier-') === 0) {
      scheduleUpdate();
    }
  });

  /* MutationObserver als Backup */
  new MutationObserver(scheduleUpdate).observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ['checked', 'class', 'aria-checked', 'data-selected'],
    childList: true,
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateButton);
  } else {
    updateButton();
  }

  window.addEventListener('load', updateButton);
}());
